import { render, staticRenderFns } from "./BaseDropdownItem.vue?vue&type=template&id=c290e0f2"
import script from "./BaseDropdownItem.vue?vue&type=script&lang=js"
export * from "./BaseDropdownItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports